export const formatPercent = (value: number | null | undefined, allowDecimals: boolean): string => {
    if (value === null || value === undefined) return '';

    if (allowDecimals) {
        return value.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
        });
    }

    return String(Math.round(value));
};

export const parsePercent = (input: string): number | null => {
    if (!input) return null;

    const normalized = input.replace(',', '.');

    const num = parseFloat(normalized);
    return Number.isNaN(num) ? null : num;
};

export const filterPercentInput = (input: string, allowDecimals: boolean): string => {
    if (allowDecimals) {
        return input.replace(/[^\d.,]/g, '');
    }
    return input.replace(/\D/g, '');
};
